var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EEFAF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H13a3 3 0 0 1-3-3V15Z",
    fill: "#77EDA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 21a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm9 0h-6v2h6v-2Z",
    fill: "#179958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16h20v3H10v-3Z",
    fill: "#179958"
  })));
};
var Memo = /*#__PURE__*/memo(SvgCard);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFRUZBRjEiLz48cGF0aCBkPSJNMTAgMTVhMyAzIDAgMCAxIDMtM2gxNGEzIDMgMCAwIDEgMyAzdjEwYTMgMyAwIDAgMS0zIDNIMTNhMyAzIDAgMCAxLTMtM1YxNVoiIGZpbGw9IiM3N0VEQTYiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE5IDIxYTEgMSAwIDEgMCAwIDIgMSAxIDAgMCAwIDAtMlptOSAwaC02djJoNnYtMloiIGZpbGw9IiMxNzk5NTgiLz48cGF0aCBkPSJNMTAgMTZoMjB2M0gxMHYtM1oiIGZpbGw9IiMxNzk5NTgiLz48L3N2Zz4=";